import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { getQuotesURL } from 'growth-payments-core/urls/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const QuotesPopoverEmptyState = () => {
  return /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
    image: "quotes",
    title: "draftPlugins.quotes.popover.zeroState.header",
    description: "draftPlugins.quotes.popover.zeroState.description",
    buttonLabel: 'draftPlugins.quotes.popover.zeroState.buttonCPQ',
    buttonLink: getQuotesURL()
  });
};
export default QuotesPopoverEmptyState;